var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43.5,
    r: 43,
    fill: "#E7ECF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.125 27.875H33.375C32.6457 27.875 31.9462 28.1647 31.4305 28.6805C30.9147 29.1962 30.625 29.8957 30.625 30.625V33.375H27.875C27.1457 33.375 26.4462 33.6647 25.9305 34.1805C25.4147 34.6962 25.125 35.3957 25.125 36.125V55.375C25.125 56.1043 25.4147 56.8038 25.9305 57.3195C26.4462 57.8353 27.1457 58.125 27.875 58.125H52.625C53.3543 58.125 54.0538 57.8353 54.5695 57.3195C55.0853 56.8038 55.375 56.1043 55.375 55.375V52.625H58.125C58.8543 52.625 59.5538 52.3353 60.0695 51.8195C60.5853 51.3038 60.875 50.6043 60.875 49.875V30.625C60.875 29.8957 60.5853 29.1962 60.0695 28.6805C59.5538 28.1647 58.8543 27.875 58.125 27.875ZM52.625 36.125V38.875H27.875V36.125H52.625ZM52.625 55.375H27.875V41.625H52.625V55.375ZM58.125 49.875H55.375V36.125C55.375 35.3957 55.0853 34.6962 54.5695 34.1805C54.0538 33.6647 53.3543 33.375 52.625 33.375H33.375V30.625H58.125V49.875Z",
    fill: "#929EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentCampaign);
export default __webpack_public_path__ + "static/media/AppointmentCampaign.65858d9e.svg";
export { ForwardRef as ReactComponent };